import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'
import accessGroups from 'modules/core/store/collections/accessGroups'
import type AccessGroup from 'modules/core/store/models/AccessGroup'

interface IGroup {
  [key: string]: any
}

class Group extends Model<IGroup> {
  static urlRoot() {
    return '/posts/groups'
  }

  constructor(attr: IGroup = {}) {
    super(attr)
    makeObservable(this, {
      accessGroup: computed,
      isDefault: computed,
    })
  }

  get accessGroup(): AccessGroup | null | undefined {
    return accessGroups.find({
      id: this.attributes.access_group_id,
    })
  }

  get isDefault(): boolean {
    return !!this.attributes.default
  }
}

export default Group
